import React from 'react';
import { motion } from 'framer-motion';

/**
 * NailFinishSelector Component
 * 
 * Displays nail finish/look options as buttons
 * Selection only updates state - does NOT trigger generation
 */

const NailFinishSelector = ({ 
  finishes, 
  selectedFinishId, 
  onFinishSelect, 
  disabled = false 
}) => {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2">
        {finishes.map((finish) => {
          const isSelected = selectedFinishId === finish.id;
          
          return (
            <motion.button
              key={finish.id}
              onClick={() => !disabled && onFinishSelect(finish.id)}
              disabled={disabled}
              className={`
                relative px-3 py-2.5 rounded-lg text-sm font-medium
                border-2 transition-all duration-200
                ${isSelected 
                  ? 'border-[#7d6633] bg-[#7d6633]/10 text-[#7d6633] dark:text-[#a0824a]' 
                  : 'border-zinc-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-[#7d6633]/50'}
              `}
              whileHover={!disabled ? { scale: 1.03 } : {}}
              whileTap={!disabled ? { scale: 0.97 } : {}}
            >
              {finish.name}
              
              {/* Selected indicator */}
              {isSelected && (
                <div className="absolute top-1 right-1 bg-[#7d6633] text-white rounded-full p-0.5">
                  <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default NailFinishSelector;
